import React from "react";
import {
  BiCog,
  BiShield,
  BiBell,
  BiCreditCard,
  BiKey,
  BiUserCircle,
} from "react-icons/bi";
import { HiDevicePhoneMobile, HiEnvelope } from "react-icons/hi2";
import "../styles/Pages.css";

const ManagePage = ({ user }) => {
  const settingsGroups = [
    {
      title: "Account Settings",
      items: [
        {
          icon: <BiUserCircle />,
          label: "Personal Information",
          description: "Update your profile details",
        },
        {
          icon: <HiEnvelope />,
          label: "Email Preferences",
          description: "Manage email notifications",
        },
        {
          icon: <HiDevicePhoneMobile />,
          label: "Phone Number",
          description: "Update contact number",
        },
        {
          icon: <BiKey />,
          label: "Change Password",
          description: "Update your security credentials",
        },
      ],
    },
    {
      title: "Security & Privacy",
      items: [
        {
          icon: <BiShield />,
          label: "Two-Factor Authentication",
          description: "Enable 2FA for extra security",
        },
        {
          icon: <BiKey />,
          label: "Login History",
          description: "View recent account access",
        },
        {
          icon: <BiCreditCard />,
          label: "Linked Devices",
          description: "Manage trusted devices",
        },
        {
          icon: <BiShield />,
          label: "Privacy Settings",
          description: "Control your data sharing",
        },
      ],
    },
    {
      title: "Notifications",
      items: [
        {
          icon: <BiBell />,
          label: "Push Notifications",
          description: "Manage app notifications",
        },
        {
          icon: <HiEnvelope />,
          label: "Email Alerts",
          description: "Transaction and account alerts",
        },
        {
          icon: <HiDevicePhoneMobile />,
          label: "SMS Notifications",
          description: "Text message alerts",
        },
      ],
    },
    {
      title: "Card Management",
      items: [
        {
          icon: <BiCreditCard />,
          label: "Card Limits",
          description: "Set spending and withdrawal limits",
        },
        {
          icon: <BiCreditCard />,
          label: "Card Controls",
          description: "Enable/disable online transactions",
        },
        {
          icon: <BiCreditCard />,
          label: "Virtual Cards",
          description: "Create temporary card numbers",
        },
        {
          icon: <BiCreditCard />,
          label: "Replace Card",
          description: "Request a replacement card",
        },
      ],
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Manage Account</h1>
        <p className="page-subtitle">
          Control your account settings and preferences
        </p>
      </div>

      <div className="quick-actions-manage">
        <button className="quick-action-card">
          <BiUserCircle className="action-icon" />
          <span>Edit Profile</span>
        </button>
        <button className="quick-action-card">
          <BiShield className="action-icon" />
          <span>Security</span>
        </button>
        <button className="quick-action-card">
          <BiBell className="action-icon" />
          <span>Notifications</span>
        </button>
        <button className="quick-action-card">
          <BiCog className="action-icon" />
          <span>Preferences</span>
        </button>
      </div>

      {settingsGroups.map((group, idx) => (
        <div key={idx} className="settings-group">
          <h3 className="group-title">{group.title}</h3>
          <div className="settings-list">
            {group.items.map((item, itemIdx) => (
              <button key={itemIdx} className="setting-item">
                <div className="setting-icon">{item.icon}</div>
                <div className="setting-content">
                  <h4>{item.label}</h4>
                  <p>{item.description}</p>
                </div>
                <div className="setting-arrow">›</div>
              </button>
            ))}
          </div>
        </div>
      ))}

      <div className="danger-zone">
        <h3>Account Actions</h3>
        <div className="danger-actions">
          <button className="danger-action">
            <span>Download Account Data</span>
          </button>
          <button className="danger-action">
            <span>Temporarily Freeze Account</span>
          </button>
          <button className="danger-action critical">
            <span>Close Account</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManagePage;
